import { AxiosResponse } from "axios";

import apiClient from "../../../../shared/infrastructure/api/client";

/** One message in a shared board's mailbox. */
export type BoardMessage = { seq: number; sender: string; payload: string };

/** What one side has not seen yet, and whether the other side is polling. */
export type BoardInbox = { messages: BoardMessage[]; cursor: number; present: boolean };

/** A shared board's mailbox: the therapist's door and the patient's link. */
export const EmdrBoardAPI = {
    /** The patient's link for this session's board, and where the board starts reading. */
    link: (sessionId: string): Promise<AxiosResponse<{ share_url: string; cursor: number }>> =>
        apiClient.post(`/sessions/${sessionId}/emdr-board/link`),

    post: (sessionId: string, payload: string): Promise<AxiosResponse<void>> =>
        apiClient.post(`/sessions/${sessionId}/emdr-board/messages`, { payload }),

    messages: (sessionId: string, after: number): Promise<AxiosResponse<BoardInbox>> =>
        apiClient.get(`/sessions/${sessionId}/emdr-board/messages`, { params: { after } }),

    /** The patient's side, from the link alone. */
    join: (token: string): Promise<AxiosResponse<{ cursor: number }>> =>
        apiClient.post(`/public/emdr-board/${encodeURIComponent(token)}/join`),

    postAsPatient: (token: string, payload: string): Promise<AxiosResponse<void>> =>
        apiClient.post(`/public/emdr-board/${encodeURIComponent(token)}/messages`, { payload }),

    messagesForPatient: (token: string, after: number): Promise<AxiosResponse<BoardInbox>> =>
        apiClient.get(`/public/emdr-board/${encodeURIComponent(token)}/messages`, { params: { after } }),
};
